import { __assign } from "tslib";
import React, { lazy, Suspense, useRef, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { BiData } from '@wix/da-bi/pkg/events';
import { URLS } from '@wix/da-url';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import ChatIcon from '@wix/da-ds/pkg/Icons/24x24/Chat';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import IconButtonWithNotification from '@wix/da-ds/pkg/Buttons/IconButtonWithNotification';
import ErrorBoundary from '../../../ErrorBoundary';
import { useVerification } from '../../../VerificationPopup/withVerification';
import throttle from 'lodash/throttle';
var DesktopChatPanelDropdown = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "chat" */
        '../../../Chat/ChatPanel/DesktopChatPanelDropdown');
    });
});
import retry from '../../../utils/webpack/chunkRetry';
import s from './ChatButtonAndDropdown.scss';
export var ChatButtonAndDropdown = function (_a) {
    var chatCount = _a.chatCount, className = _a.className, iconClassName = _a.iconClassName, numberClassName = _a.numberClassName, disableDropdown = _a.disableDropdown, disableFloatingChat = _a.disableFloatingChat, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, onOpen = _a.onOpen, onClose = _a.onClose;
    var t = useTranslation().t;
    var isMounted = useIsMounted();
    var _c = useVerification(), isVerificationNeeded = _c.isVerificationNeeded, pushVerificationPopup = _c.pushVerificationPopup;
    var rootRef = useRef(null);
    var enterTimerRef = useRef();
    var throttledMouseLeave = useMemo(function () {
        return throttle(function () {
            clearTimeout(enterTimerRef.current);
            onClose && onClose();
        }, 300);
    }, [onClose]);
    var onMouseEnter = function () {
        enterTimerRef.current = setTimeout(function () {
            onOpen && onOpen();
        }, 100);
    };
    var onClosed = useCallback(function () {
        throttledMouseLeave();
    }, [throttledMouseLeave]);
    return (React.createElement("div", { className: classnames(s['root'], className), onMouseEnter: onMouseEnter, onMouseLeave: onClosed, ref: rootRef },
        !isVerificationNeeded && (React.createElement(TextButton, { className: s['a11y-toggle'], size: "medium", variant: "main", "aria-haspopup": true, "aria-expanded": isOpen, "aria-controls": "site-header-chat", onClick: isOpen ? onClose : onOpen }, t('siteHeader.chat.open'))),
        React.createElement(IconButtonWithNotification, __assign({ icon: ChatIcon, size: "medium", notificationColor: "red", iconButtonClassName: iconClassName, numberClassName: numberClassName, count: chatCount, biData: BiData({
                evid: 700,
                link_name: 'chat',
                indicator: chatCount,
            }) }, (isVerificationNeeded
            ? {
                onClick: function () { return pushVerificationPopup('chat'); },
                'aria-label': t('siteHeader.a11y.openAccountVerificationDialog'),
            }
            : {
                href: URLS.CHAT_HOME,
                'aria-label': t('chat.panel.a11y.chatButtonLink'),
            }))),
        React.createElement(ErrorBoundary, { debugComponent: "ChatButtonAndDropdown" }, isMounted && isOpen && !disableDropdown && (React.createElement(Suspense, { fallback: null },
            React.createElement(DesktopChatPanelDropdown, { id: "site-header-chat", className: classnames(s['dropdown'], isOpen && s['open'], s['a11y-dropdown']), disableFloatingChat: disableFloatingChat, onClose: onClosed }))))));
};
ChatButtonAndDropdown.displayName = 'ChatButtonAndDropdown';
export default ChatButtonAndDropdown;
//# sourceMappingURL=ChatButtonAndDropdown.js.map